import { Component, inject, Inject, Input, OnInit } from '@angular/core';
import { Customer } from '@xprojectorcore/xprojector_backend/proto/xprojector.grpc.models.pb';
import { BmsCustomer } from '@app/features/bms/models/bms-customer';
import { BmsAdminService } from '../../services/bms-admin-service';
import { BmsApartment } from '../../../models/bms-apartment';
import { BmsBuilding } from '../../../models/bms-building';
import { BmsBuildingAddress } from '../../../models/bms-buildingaddress';
import { BmsFacility } from '../../../models/bms-facility';
import { BmsRealestate } from '../../../models/bms-realestate';
import { BatteryExchange } from '@app/core/xprojector_backend/proto/xprojector.modulebms.customeradmin.pb';
import { XProjectorBmsCustomerAdminClient } from '@app/core/xprojector_backend/xprojector-bms-customeradmin-client';
import { BmsMeter } from '../../../models/bms-meter';
import { DateHelper, XprojModalService } from 'xproj-lib';
import { Timestamp } from '@app/core/xprojector_backend/proto/google/protobuf/timestamp.pb';
import { ClrDatagridSortOrder } from '@clr/angular';

@Component({
  selector: 'app-bms-battery-exchange',
  templateUrl: './bms-battery-exchange.component.html',
  styleUrls: ['./bms-battery-exchange.component.scss']
})
export class BmsBatteryExchangeComponent implements OnInit {

  private adminService: BmsAdminService = inject(BmsAdminService);
  private customerAdminClient: XProjectorBmsCustomerAdminClient = inject(XProjectorBmsCustomerAdminClient);
  public dateHelper: DateHelper = inject(DateHelper);
  private modalService: XprojModalService = inject(XprojModalService);

  @Input() customer : Customer;
  @Input() bmsCustomer : BmsCustomer;

  realestates : BmsRealestate[] = [];
  buildings : BmsBuilding[] = [];
  buildingAddresses : BmsBuildingAddress[] = [];
  apartments : BmsApartment[] = [];
  facilities : BmsFacility[] = [];
  meters : BmsMeter[] = [];

  batteryTypes : string[] = [];

  batteryExchanges : BatteryExchange[] = [];

  loadingData : boolean = false;

  apartmentsFiltered : BmsApartment[] = [];
  facilitiesFiltered : BmsFacility[] = [];
  metersFiltered : BmsMeter[] = [];

  batteryExchangeData : {
    batteryExchange : BatteryExchange | undefined,
    exchangeDate : Date,
    meter : BmsMeter | undefined,
    address : string,
    apartment : string
  }[] = [];

  addBatteryExchangeData : {
    nodeId : number,
    nodeTypeId : string,
    batteryType : string,
    exchangeDateString : string,
    exchangeDate : Date,
    message : string,
    buildingAddress : BmsBuildingAddress,
    apartment : BmsApartment,
    facility : BmsFacility,
    meter : BmsMeter
  } = { nodeId : 0, nodeTypeId : '', batteryType : '', exchangeDate : new Date(),
    exchangeDateString : '', message : '', buildingAddress : undefined, apartment : undefined, facility : undefined, meter : undefined };

  ascSort = ClrDatagridSortOrder.ASC;
  descSort = ClrDatagridSortOrder.DESC;


  constructor() { }

  ngOnInit() {
    this.updateCustomerData();
  }

  async updateCustomerData(forceReload: boolean = false) {
    if (this.bmsCustomer?.id > 0) {
      try {
        this.loadingData = true;

        await this.updateBatteryExchanges();

        if (forceReload || this.realestates.length == 0) {
          this.realestates = await this.adminService.getRealestates(this.bmsCustomer.id, forceReload);
          this.buildings = await this.adminService.getBuildings(this.bmsCustomer.id, forceReload);
          this.buildingAddresses = await this.adminService.getBuildingAddresses(this.bmsCustomer.id, forceReload);
          this.apartments = await this.adminService.getApartments(this.bmsCustomer.id, forceReload);
          this.facilities = await this.adminService.getFacilities(this.bmsCustomer.id, forceReload);
          this.meters = await this.adminService.getMeters(this.bmsCustomer.id);
        }

        this.batteryExchangeData = [];
        this.batteryExchanges.forEach(x => {
          let exchangeData = { meter : undefined, batteryExchange : undefined, address : '', exchangeDate : new Date(), exchangeDateString : '', message : '', apartment : ''};

          exchangeData.batteryExchange = x;
          exchangeData.exchangeDate = x.timestamp.toDate();

          if (x.nodeTypeId == '_x_bms_meter') {
            let meter = this.meters.find(m => m.id == +x.nodeId);
            if (meter) {
              exchangeData.meter = meter;

              if (meter.apartmentId > 0) {
                let apartment = this.apartments.find(a => a.id == meter.apartmentId);
                if (apartment) {
                  exchangeData.apartment = apartment.externalId;
                }
              }
              else if (meter.facilityId > 0) {
                let facility = this.facilities.find(a => a.id == meter.facilityId);
                if (facility) {
                  exchangeData.apartment = facility.externalId;
                }
              }

              if (meter.buildingAddressId > 0) {
                let buildingAddress = this.buildingAddresses.find(a => a.id == meter.buildingAddressId);
                if (buildingAddress) {
                  exchangeData.address = buildingAddress.description;
                }
              }
            }
          }
          else if (x.nodeTypeId == '_x_bms_apartment') {
            let apartment = this.apartments.find(a => a.id == +x.nodeId);
            if (apartment) {
              exchangeData.apartment = apartment.externalId;

              if (apartment.buildingAddressId > 0) {
                let buildingAddress = this.buildingAddresses.find(a => a.id == apartment.buildingAddressId);
                if (buildingAddress) {
                  exchangeData.address = buildingAddress.description;
                }
              }
            }
          }
          else if (x.nodeTypeId == '_x_bms_facility') {
            let facility = this.facilities.find(a => a.id == +x.nodeId);
            if (facility) {
              exchangeData.apartment = facility.externalId;

              if (facility.buildingAddressId > 0) {
                let buildingAddress = this.buildingAddresses.find(a => a.id == facility.buildingAddressId);
                if (buildingAddress) {
                  exchangeData.address = buildingAddress.description;
                }
              }
            }
          }

          this.batteryExchangeData.push(exchangeData);
        });
      }
      finally {
        console.log('this.batteryExchangeData', this.batteryExchangeData);
        this.loadingData = false;
        this.clearBatteryExchangeData();
      }
    }
  }

  async updateBatteryExchanges() {
    if (this.bmsCustomer?.id > 0) {
      if (this.batteryTypes.length == 0) {
        this.batteryTypes = await this.customerAdminClient.getBatteryTypes();
      }

      this.batteryExchanges = await this.customerAdminClient.getBatteryExchanges(this.bmsCustomer.customerId);
    }
  }

  clearBatteryExchangeData() {
    this.addBatteryExchangeData = {
      nodeId : 0,
      nodeTypeId : '',
      batteryType : '',
      exchangeDate : new Date(),
      exchangeDateString : '',
      message : '',
      buildingAddress : undefined,
      apartment : undefined,
      facility : undefined,
      meter : undefined};

      this.apartmentsFiltered = this.apartments;
      this.facilitiesFiltered = this.facilities;
      this.metersFiltered = this.meters;

      this.addBatteryExchangeData.exchangeDateString = this.dateHelper.formatByString(this.addBatteryExchangeData.exchangeDate, 'yyyy-MM-dd');
  }

  async addBatteryExchange() {
    if ((this.addBatteryExchangeData.meter || this.addBatteryExchangeData.apartment || this.addBatteryExchangeData.facility) && this.addBatteryExchangeData.exchangeDateString?.length > 0) {
      try {
        this.addBatteryExchangeData.exchangeDate = this.dateHelper.utils.parse(this.addBatteryExchangeData.exchangeDateString, 'yyyy-MM-dd');

        let batteryExchange = new BatteryExchange();

        if (this.addBatteryExchangeData.meter) {
          batteryExchange.nodeId = this.addBatteryExchangeData.meter.id + '';
          batteryExchange.nodeTypeId = this.addBatteryExchangeData.meter.typeId;
        }
        else if (this.addBatteryExchangeData.apartment) {
          batteryExchange.nodeId = this.addBatteryExchangeData.apartment.id + '';
          batteryExchange.nodeTypeId = '_x_bms_apartment';
        }
        else if (this.addBatteryExchangeData.facility) {
          batteryExchange.nodeId = this.addBatteryExchangeData.facility.id + '';
          batteryExchange.nodeTypeId = '_x_bms_facility';
        }

        batteryExchange.timestamp = Timestamp.fromDate(this.addBatteryExchangeData.exchangeDate);
        batteryExchange.message = this.addBatteryExchangeData.message;
        batteryExchange.batteryType = this.addBatteryExchangeData.batteryType;

        let result = await this.customerAdminClient.upsertBatteryExchange(this.bmsCustomer.customerId, batteryExchange);

        if (result.ok) {
            await this.updateCustomerData();
        }

      }
      catch {

      }
    }
  }

  async deleteBatteryExchange(batteryExchange : BatteryExchange) {
    if (batteryExchange) {
      var doDelete = await this.modalService.ShowConfirmModalAsync({
        header: 'Delete battery exchange',
        description: 'Delete battery exchange, are you sure?',
        ok: 'Ok',
        cancel: 'Cancel'
      });

      if (doDelete) {
        let result = await this.customerAdminClient.deleteBatteryExchange(this.bmsCustomer.customerId, batteryExchange.id);

        if (result.ok) {
          await this.updateCustomerData();
        }
      }
    }
  }


  addressChanged() {
    if (this.addBatteryExchangeData.buildingAddress) {
      this.apartmentsFiltered = this.apartments.filter(x => x.buildingAddressId == this.addBatteryExchangeData.buildingAddress.id);
      this.facilitiesFiltered = this.facilities.filter(x => x.buildingAddressId == this.addBatteryExchangeData.buildingAddress.id);
    }
    else {
      this.apartmentsFiltered = this.apartments;
    }
  }

  apartmentChanged() {
    if (this.addBatteryExchangeData.apartment) {
      this.metersFiltered = this.meters.filter(x => x.apartmentId == this.addBatteryExchangeData.apartment.id);
    }
    else {
      this.metersFiltered = this.meters;
    }
  }

  facilityChanged() {
    if (this.addBatteryExchangeData.facility) {
      this.metersFiltered = this.meters.filter(x => x.facilityId == this.addBatteryExchangeData.facility.id);
    }
    else {
      this.metersFiltered = this.meters;
    }
  }

}
